





















import { Component, Vue } from 'vue-property-decorator';
import CenterOrder from './Order.vue';

@Component({
  components: {
    CenterOrder,
  },
})
export default class CenterIndex extends Vue {
  private uploadimg: string = '';
  private showNews() {
    console.log('news');
  }
  private showSetting() {
    console.log('setting');
    this.$router.push('/center/setting');
  }
  private editAvatar() {
    const file = this.$refs.upload.files[0];
    if (file) {
      const URL = window.URL || window.webkitURL;
      const imageURL = URL.createObjectURL(file);
      const upload = {
        file,
        url: imageURL,
      };
      this.$store.dispatch('updateUserAvatar', upload);
    }
  }
  get userInfo() {
    return this.$store.state.userInfo;
  }
}
